/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ palette: { grey }, spacing: { unit }, typography }) => ({
  wrapper: {
    width: 300,
    margin: '0 auto'
  },
  extraHeaderOptions: {
    margin: [2.5 * unit, 6.25 * unit]
  },
  dropdown: {
    '& > label': {
      width: '100%'
    }
  },
  delimiter: {
    '& [class*="dropdown"]': {
      zIndex: 4
    }
  },
  endOfRecord: {
    '& [class*="dropdown"]': {
      zIndex: 3
    }
  },
  tableCheckbox: {
    display: 'flex',
    marginTop: 5,
    marginRight: 10
  },
  mapFormatWrapper: {
    padding: [30, 0],
    textAlign: 'center'
  },
  mapFormatLabel: {
    color: grey.G600,
    fontSize: 12,
    fontWeight: typography.fontWeightHeavy,
    marginBottom: 10,
    textTransform: 'uppercase'
  },
  mapFormat: {
    justifyContent: 'center'
  }
}));
